// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.magicform-header-button {
  color: white !important;
  font-size: 16px !important;
  background: transparent !important;
  border: 0;
  cursor: pointer;
  margin-right: 1rem;
  padding: 0 !important;
  padding-inline-start: 0 !important;
  padding-inline-end: 0 !important;
  padding-block-start: 0 !important;
  padding-block-end: 0 !important;
}

.magicform-header-company-icon {
  width: 35px; /* Set a fixed width for the icon */
  height: 35px; /* Set a fixed height for the icon */
  border-radius: 50%; /* Make the icon a circle */
  background-color: white; /* Set a background color for the icon */
  background-position: center; /* Center the image within the icon */
  background-repeat: no-repeat;
  background-size: cover;
}

.magicform-header-company-info {
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 !important;
  margin-left: 10px !important;
}

.magicform-header-company-container {
  display: flex;
  align-items: center;
  justify-content: start;
  margin-left: 10px;
}

.magicform-header-online-indicator {
  margin: 0 0.75rem;
  width: 0.8rem;
  height: 0.8rem;
  background-color: lawngreen; /* Bright green color */
  border-radius: 50%;
  box-shadow: inset -1px -1px 2px rgba(0, 0, 0, 0.15); /* Slight shadow */
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatHeader/ChatHeader.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,gCAAgC;EAChC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,WAAW,EAAE,mCAAmC;EAChD,YAAY,EAAE,oCAAoC;EAClD,kBAAkB,EAAE,2BAA2B;EAC/C,uBAAuB,EAAE,wCAAwC;EACjE,2BAA2B,EAAE,qCAAqC;EAClE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,2BAA2B,EAAE,uBAAuB;EACpD,kBAAkB;EAClB,mDAAmD,EAAE,kBAAkB;AACzE","sourcesContent":[".magicform-header-button {\n  color: white !important;\n  font-size: 16px !important;\n  background: transparent !important;\n  border: 0;\n  cursor: pointer;\n  margin-right: 1rem;\n  padding: 0 !important;\n  padding-inline-start: 0 !important;\n  padding-inline-end: 0 !important;\n  padding-block-start: 0 !important;\n  padding-block-end: 0 !important;\n}\n\n.magicform-header-company-icon {\n  width: 35px; /* Set a fixed width for the icon */\n  height: 35px; /* Set a fixed height for the icon */\n  border-radius: 50%; /* Make the icon a circle */\n  background-color: white; /* Set a background color for the icon */\n  background-position: center; /* Center the image within the icon */\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.magicform-header-company-info {\n  height: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 0 !important;\n  margin-left: 10px !important;\n}\n\n.magicform-header-company-container {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  margin-left: 10px;\n}\n\n.magicform-header-online-indicator {\n  margin: 0 0.75rem;\n  width: 0.8rem;\n  height: 0.8rem;\n  background-color: lawngreen; /* Bright green color */\n  border-radius: 50%;\n  box-shadow: inset -1px -1px 2px rgba(0, 0, 0, 0.15); /* Slight shadow */\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `magicform-header-button`;
export { _1 as "magicform-header-button" };
var _2 = `magicform-header-company-icon`;
export { _2 as "magicform-header-company-icon" };
var _3 = `magicform-header-company-info`;
export { _3 as "magicform-header-company-info" };
var _4 = `magicform-header-company-container`;
export { _4 as "magicform-header-company-container" };
var _5 = `magicform-header-online-indicator`;
export { _5 as "magicform-header-online-indicator" };
export default ___CSS_LOADER_EXPORT___;
